import { datadogRum } from "@datadog/browser-rum";
import { addReactError as addReactErrorDatadog } from "@datadog/browser-rum-react";
import { useAtomValue } from "jotai";
import { type ErrorInfo, useEffect } from "react";
import { currentUserAtom } from "./store/userStore";

datadogRum.init({
    applicationId: import.meta.env.VITE_DATADOG_APP_ID,
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: import.meta.env.VITE_DATADOG_SITE || "datadoghq.eu",
    service: import.meta.env.VITE_DATADOG_SERVICE || "ditto-frontend",
    env: import.meta.env.VITE_DATADOG_ENV || "development",
    version: import.meta.env.VITE_DATADOG_VERSION || "1.0.0",

    sessionSampleRate: parseFloat(
        import.meta.env.VITE_DATADOG_SESSION_SAMPLE_RATE || "100",
    ),
    sessionReplaySampleRate: parseFloat(
        import.meta.env.VITE_DATADOG_SESSION_REPLAY_SAMPLE_RATE || "20",
    ),
    trackUserInteractions: true,
    traceContextInjection: "all",
    traceSampleRate: parseFloat(
        import.meta.env.VITE_DATADOG_TRACE_SAMPLE_RATE || "100",
    ),
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    // Add these for better tracing
    allowedTracingUrls:
        import.meta.env.VITE_DATADOG_ALLOWED_TRACING_URLS?.split(",") || [],
    enableExperimentalFeatures: ["distributed-tracing"],
});

export const useSetDatadogRumUser = () => {
    const { data } = useAtomValue(currentUserAtom);

    useEffect(() => {
        const user = data?.currentUser;

        if (user)
            datadogRum.setUser({
                id: user.id,
                name: `${user.firstName} ${user.lastName}`,
                email: user.email,
                tenant: user.permission?.tenant?.uname,
                role: user.permission?.role,
            });
    }, [data?.currentUser]);
};

export function addReactError(error: Error, info: ErrorInfo = {}) {
    try {
        addReactErrorDatadog(error, info);
    } catch (e) {
        console.error(e);
    }
}
